var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI2A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.75 19.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-I2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.45,18.1c.13-.6,0-1.19.27-1.81s.11-.31.17-.85c0-.3,1.77-4.26,2.1-5a2.7,2.7,0,0,0,.35-1.64c0-1.21.17-7.2-.18-7.88C13.57-.27,12.07,0,10.93,0H2.87C1.74,0,.32-.14.06,1.3c-.11.61,0,11,0,12.12,0,.85-.14,3.25.19,3.89.56,1.12,2.15.82,3.22.82s7.58.07,8,0ZM2.19,12.86H5.92a.68.68,0,0,1,.68.68v1.11a.68.68,0,0,1-.68.69H2.19a.69.69,0,0,1-.68-.69V13.54A.67.67,0,0,1,2.19,12.86Zm0-4.29h9.15a.69.69,0,0,1,.69.69h0a.69.69,0,0,1-.69.69H2.23a.69.69,0,0,1-.69-.69h0A.69.69,0,0,1,2.23,8.57Zm0-2.71h9.15a.69.69,0,0,1,.69.69h0a.7.7,0,0,1-.69.7H2.23a.69.69,0,0,1-.69-.7h0A.69.69,0,0,1,2.23,5.86Zm0-2.64h9.15a.69.69,0,0,1,.69.69h0a.7.7,0,0,1-.69.7H2.23a.7.7,0,0,1-.69-.7h0A.69.69,0,0,1,2.23,3.22Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3,6.92,15.09,9.83a57.71,57.71,0,0,0-2.42,5.92l2,.83,2.12-4.77c.48-1.08,1.63-4,2-4.78a.9.9,0,0,1,.37.68c.12,1-1.94,4.18-1.84,5.11.09.27.3.33.62-.41L19,9.89c.67-1.53,1.17-2,0-3.45l0-1c0-.33.23-.5.2-.88A.73.73,0,0,0,18,4.12c-.23.27-.11.5-.45.72-.74.46-.8.94-1.25,2.09Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.17,19.56c.47,0,.24-.21.59-.56.62-.62,1.39-1.26,1.49-1.87l-1.72-.69L12.25,18c0,.25,0,.71,0,.91-.05.38-.26.25-.06.66Z",
    transform: "translate(0 0)",
    fill: "#ed7333",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI2A);
export default __webpack_public_path__ + "static/media/I2A.404fb703f6faaff93145e978e71701b7.svg";
export { ForwardRef as ReactComponent };